@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/business-cards-2x3/koan-business-card-stack-content/koan-business-card-stack-content.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
:host {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  padding: 0.5rem;
  box-sizing: border-box;
}
:host .main-section {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
  border: 0.15625rem solid #222222;
}
:host .main-section .brush-stroke {
  height: 13.625rem;
  width: 6.125rem;
  position: absolute;
  right: 1rem;
  z-index: 0;
}
:host .main-section .left-container {
  display: flex;
  padding-top: 1.125rem;
  flex-direction: column;
  align-items: center;
  padding-left: 0.25rem;
  gap: 0.5rem;
  flex: 1 0 0;
  align-self: stretch;
  z-index: 10;
}
:host .main-section .left-container .product-card-name {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 1.5rem;
  text-align: center;
  height: 3rem;
}
:host .main-section .left-container .product-card-size {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 1rem;
}
:host .main-section .left-container .properties-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.625rem;
}
:host .main-section .left-container .properties-container .property-container {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  align-items: center;
}
:host .main-section .left-container .properties-container .property-container .title {
  font-size: 0.9375rem;
}
:host .main-section .left-container .properties-container .property-container .value {
  font-size: 1.3125rem;
}
:host .main-section .left-container .product-card-price-container {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
}
:host .main-section .left-container .product-card-price-container ::ng-deep .product-variant-price {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 0.375rem;
}
:host .main-section .left-container .product-card-price-container ::ng-deep .product-variant-price .product-variant-previous-price {
  font-size: 1.125rem;
}
:host .main-section .left-container .product-card-price-container ::ng-deep .product-variant-price .product-variant-previous-price .product-variant-price-decoration {
  font-size: 1.125rem;
}
:host .main-section .left-container .product-card-price-container ::ng-deep .product-variant-price .product-variant-current-price {
  font-size: 1.625rem;
}
:host .main-section .left-container .product-card-price-container ::ng-deep .product-variant-price .product-variant-price-decoration {
  font-size: 1.625rem;
}
:host .main-section .left-container .product-card-badge-and-label-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  gap: 0.375rem;
  height: 0.875rem;
}
:host .main-section .left-container .product-card-badge-and-label-container .product-card-badge {
  height: 1rem;
  width: 1rem;
}
:host .main-section .left-container .product-card-badge-and-label-container .print-card-label {
  height: fit-content;
  margin: 0;
  padding: 0;
}
:host .main-section .left-container .product-card-badge-and-label-container .print-card-label ::ng-deep .product-label {
  font-family: rubik, sans-serif;
  font-weight: 500;
  font-size: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.125rem;
  padding: 0.1875rem 0.1875rem 0.0625rem;
  width: fit-content;
}
:host .main-section .right-container {
  display: flex;
  width: 6.25rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  z-index: 10;
}
:host .main-section .right-container .product-card-image {
  width: 5rem;
  height: auto;
}
:host .main-section .right-container .product-card-brand {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 1.0625rem;
  text-align: center;
}
:host ::ng-deep .force-italic-style * {
  font-family: "NeueHaasGroteskDisplay", sans-serif;
  font-weight: 400;
  font-style: italic;
}
:host ::ng-deep .force-bold-style * {
  font-family: "NeueHaasGroteskDisplay", sans-serif;
  font-weight: 700;
  font-style: normal;
}
/*# sourceMappingURL=koan-business-card-stack-content.component.css.map */
